import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Constants } from '@app/shared/class/constants.class';

import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { TransactionalEventsService } from '@core/services/transactional-events.service';
import { TransactionalEvent } from '@shared/interfaces/transactional-event';

@Component({
  selector: 'app-transactional-events-edit',
  templateUrl: './transactional-events-edit.component.html'
})
export class TransactionalEventsEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public transactionalEvent: TransactionalEvent;
  public transactionalEventForm: FormGroup;

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private transactionalEventsService: TransactionalEventsService,
    public dialogRef: MatDialogRef<TransactionalEventsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.constants.title = this.appConfig.LANG.transactionalEvents.title;
    this.transactionalEventForm = new FormGroup({
      name: new FormControl('', Validators.required)
    });
    this.constants.action = this.data.action;

    if (this.constants.action === this.appConfig.ACTIONS.edit.id) {
      this.constants.title =
        this.appConfig.LANG.title.edit + ' ' + this.constants.title;
      this.transactionalEvent = this.data.item;
      this.transactionalEventForm.addControl(
        'id',
        new FormControl(this.transactionalEvent.id, [Validators.required])
      );
      this.transactionalEventForm.patchValue({
        id: this.transactionalEvent.id,
        name: this.transactionalEvent.name
      });
    } else if (this.constants.action === this.appConfig.ACTIONS.add.id) {
      this.constants.title =
        this.appConfig.LANG.title.add + ' ' + this.constants.title;
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.transactionalEventForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.constants.action,
        form,
        this.dialogRef,
        this.transactionalEventsService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }
}
